import React from "react";
import "./Information.css";

type InformationProps = {
    message: string;
}

const Information: React.FC<InformationProps> = ({message})=>  {
    return (
        <div id="information" role="status" aria-live="polite">
            <p>
                {message}
            </p>
        </div>
    );
}

export default Information